const QUERY = '(prefers-reduced-motion: reduce)';

/** Single source of truth for motion opt-out: every 3D hook checks this before binding listeners. */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(QUERY).matches;
}

/** Subscribes to OS-level motion preference changes so scenes can rebind without a reload. */
export function watchReducedMotion(onChange: (reduced: boolean) => void): () => void {
  const media = window.matchMedia(QUERY);
  const handler = (event: MediaQueryListEvent) => onChange(event.matches);
  media.addEventListener('change', handler);
  return () => media.removeEventListener('change', handler);
}

export function clamp(value: number, min = -1, max = 1): number {
  return Math.min(max, Math.max(min, value));
}
